module.exports = __webpack_public_path__ + "img/minus-big.d43f3986.svg";